eventDetail.eventDetailInlineModule = {
    // Funkcia na nacitanie a zobrazenie detailu zapasu priamo do listu zapasov
    showEventDetailInline: function(eventID, force) {
        try {
            if (eventID) {
                if (!force) {
                    var openedEvent = $("#section li#M" + eventID);
                    // Toggle inline detailu zapasu
                    if (openedEvent.hasClass("detail-inline-opened")) {
                        openedEvent.removeClass("detail-inline-opened");
                        openedEvent.find(".event-detail-inline").remove();
                        offer.inlineDetail = false;
                        main.closeDialog();
                        shared.scrollModule.scrollButtons("table");
                        return true;
                    } else {
                        var toDelete = $("#section .event-detail-inline");
                        toDelete.parent().removeClass("detail-inline-opened");
                        $(toDelete).remove();
                        shared.scrollModule.scrollButtons("table");
                    }
                }
                if (!(virtualEvent = $("#events #M" + eventID + ".virtual-event")).find(".ui-block-1 a").hasClass("game-ended")) {
                    // Otvori video alebo detail virtualnej hry
                    if ((channel = virtualEvent.find(".ui-block-5 a")).hasClass("virtual-game-play")) {
                        if (!channel.hasClass("virtual-game-playing")) {
                            $("#events .virtual-event .virtual-game-playing").removeClass("virtual-game-playing");
                            virtualEvent.find(".ui-block-5 a").addClass("virtual-game-playing");
                            if (virtualEvent !== 'undefined' && virtualEvent != stored.topScreenVgChannel) {
                                stored.topScreenVgVirtualLeague = parseInt(virtualEvent.children("span").attr("id").replace(/\D/g, ''));
                                stored.topScreenVgChannel = parseInt(channel.attr("channel"));
                                communication.topScreen(stored.topScreenActive, {
                                    screenShow: true,
                                    gameID: offer.regionID,
                                    leagueID: stored.topScreenVgVirtualLeague,
                                    channelID: stored.topScreenVgChannel
                                });
                            }
                        }
                    } else {
                        service.loadPure('sportsBookEventDetailInline', eventID);
                    }
                }
                return true;
            } else {
                return false;
            }
        } catch (e) {
            main.createLog(2, "showEventDetailInline", "eventID: " + eventID + " # ERROR: " + e);
            return false;
        }
    },

    // Nacitanie a zobrazenie Event detailu v liste zapasov
    eventDetailInlineRender: function(data) {
        try {
            if (data && !data.ErrorType && data.Event && data.EventChanceTypes) {
                var actualLeague;
                // Pripravi Hlavicky - Labels
                if (data.Event.LeagueCupID) {
                    if (!stored.InlineDetailCompetitors) {
                        stored.InlineDetailCompetitors = {
                            602578: { // UOF PSY
                                columnLabels: ['1', '1 - 2'],
                                competitorChtIDs: ['uf:866', 'uf:868'],
                                competitorByPlayerID: true,
                            },
                            607002: { // KRN PSY
                                columnLabels: ['1'],
                                competitorChtIDs: ['uf:866'],
                                competitorByPlayerID: false,
                            },
                            602577: { // UOF Kone
                                columnLabels: ['1', '1 - 3'],
                                competitorChtIDs: ['uf:866', 'uf:868'],
                                competitorByPlayerID: true,
                            },
                            607003: { // KRN Kone
                                columnLabels: ['1'],
                                competitorChtIDs: ['uf:866'],
                                competitorByPlayerID: false,
                            }
                        };
                    }
                    actualLeague = stored.InlineDetailCompetitors[data.Event.LeagueCupID];

                }
                if (actualLeague.competitorByPlayerID) {
                    var chanceTypesInline = {};
                    // Vybere len ChanceTypes na zobrazenie do inline detailu
                    Object.keys(data.EventChanceTypes).forEach(function(eChtKey) {
                        if (actualLeague.competitorChtIDs.indexOf(data.EventChanceTypes[eChtKey].ChanceTypeID) !== -1) {
                            chanceTypesInline[eChtKey] = data.EventChanceTypes[eChtKey];
                        }
                    });
                    data.EventChanceTypes = chanceTypesInline;
                }

                // Vytvori competitorov
                var competitors = [];
                Object.keys(data.Labels).forEach(function(labelKey) {
                    if ((actualLeague.competitorByPlayerID && (data.Labels[labelKey].Typ === "PL")) ||
                        (!actualLeague.competitorByPlayerID && data.Labels[labelKey].Typ === "CP")) {
                        competitors.push(data.Labels[labelKey]);
                    }
                });

                // Priradi oddy ku competitorom
                competitors.map(function(rl) {
                    rl.odds = [];
                    var nameAssigned = false;
                    data.Odds.forEach(function(odd) {
                        if (rl.ID == ((actualLeague.competitorByPlayerID)? odd.PlayerID : Number(odd.CompetitorID))) {
                            var chanceTypeID = odd.EventChanceTypeID;
                            
                            if (data.EventChanceTypes[chanceTypeID]) {
                                odd.Order = data.EventChanceTypes[chanceTypeID].Order;
                                odd.BetType = data.EventChanceTypes[chanceTypeID].BetType;
                                odd.ChanceTypeID = data.EventChanceTypes[chanceTypeID].ChanceTypeID;
                                odd.ChanceTypeName = data.EventChanceTypes[chanceTypeID].ChanceTypeName;

                                if (!nameAssigned) {
                                    // cislo + meno competitora
                                    rl.Name = '#' + odd.TipType + ' - ' + rl.Name;
                                    // Poradie Competitora
                                    rl.TipOrder = odd.TipOrder;
                                    nameAssigned = true;
                                }
                                rl.odds.push(odd);
                                Object.assign(rl.odds[0], data.EventChanceTypes[chanceTypeID]);
                            }
                        }
                    });
                });

                // Vytvori z opakujucich sa competitorov pole s unikatnymi competitormi
                var distinctCompetitors = [];
                if (actualLeague.competitorByPlayerID) {
                    distinctCompetitors = competitors;
                } else {
                    for (var c = 0; c < competitors.length; c++) {
                        var containing = false;
                        for (var dc = 0; dc < distinctCompetitors.length; dc++) {
                            if (distinctCompetitors[dc].Name === competitors[c].Name) {
                            containing = true;
                            // ak uz v poli unikatnych 'competitors' existuje odd
                            distinctCompetitors[dc].odds.push(competitors[c].odds[0]);
                            }
                        }
                        if (!containing) distinctCompetitors.push(competitors[c]);
                    }
                }
                delete competitors;

                // Sortovanie - poradie competitorov
                distinctCompetitors.sort(function (a, b) {
                    return a.TipOrder - b.TipOrder;
                });

                // Sortovanie - poradie chanceTypov
                distinctCompetitors.forEach(function(item){
                    item.odds.sort(function (a, b) {
                        return a.Order - b.Order;
                    });
                });

                var eventInlineData = {
                    Competitors: distinctCompetitors,
                    Event: data.Event,
                    ColumnLabels: actualLeague.columnLabels,
                    EventChanceTypes: data.EventChanceTypes
                };

                // Priprava html pre purejs
                var detailInline = $('#eventDetailInline').clone().removeAttr("id").addClass("event-detail-inline");
                $("#section li#M" + data.Event.EventID).append(detailInline).addClass("detail-inline-opened");
                directives.eventDetailInlineDirective.eventDetailInline();
                if ($("#M" + data.Event.EventID + " .event-detail-inline").length) {
                    $p("#M" + data.Event.EventID + " .event-detail-inline").render(eventInlineData, T.eventDetailInline);
                    offer.inlineDetail = true;
                    // Zobrazi/skryje scroll tlacidla, naskroluje na inline detail zapasu
                    shared.scrollModule.scrollButtons("table");
                    var scrollToDetail = $("#section li#M" + data.Event.EventID).offset().top - 160;
                    setTimeout(function() {
                        shared.scrollModule.checkScroll(".content-table", "#events", scrollToDetail, "fast");
                    }, 500);
                }
                return true;
            } else {
                modal.showErrObj(2, 5, {err1: texts.OfferNoEvent, errType: "OfferNoEvent"});
                return false;
            }
        }  catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    }
};
